// Polish resources for the public landing page (namespace "landing").
// Keep keys in sync with ../en/landing.ts.
//
// 2026-09-19: Domi przywrócił wcześniejszą kompozycję z trzema editami.
//
// 2026-09-20, runda 37-R3 (strona publiczna jako droga do akcji): nad nagłówkiem stoi
// nadtytuł z adresatem.
//
// 2026-09-23, paczka HD: właściciel wybrał hero D („D najlepsze”, 22.09), więc decyzja A / B
// jest zamknięta: `hero.title`, `hero.titleA` i `hero.lead` odeszły, a nagłówek, zdanie pod nim
// i słowa mapy „schemat metra” to klucze z MAPY D (`titleD`, `leadD`, `how`, `map.*`, `mapAlt`).
// Druga grafika („Jedna seria. Wszystkie Twoje konta.”) wypadła razem z `accountsMap.*`: hero
// niesie tę samą treść na pierwszym ekranie.
//
// CREDIBILITY PASS (P06) nadal obowiązuje: liczby na stronie są prawdziwe albo przychodzą
// z `/api/billing/plans` (`gem_costs.render`, `gem_costs.publish`, cena Startera) albo
// z `lib/startBonus.ts`, czyli z katalogu w `app/billing/costs.py`. Jedna stopka = jedne
// klucze: `footer.*` obsługuje Landing, Cennik, FAQ, strony prawne i 404.
export const landing = {
  nav: {
    funkcje: 'Funkcje',
    jak: 'Jak to działa',
    cennik: 'Cennik',
    faq: 'FAQ',
    toPanel: 'Przejdź do editów',
    login: 'Zaloguj się',
    startFree: 'Zacznij za darmo',
  },
  hero: {
    // Adresat nad nagłówkiem: jedno zdanie mniej w samym nagłówku (artboard 01).
    eyebrow: 'Dla artystów muzycznych',
    // Hero D (MAPA D): dwa zdania, każde w osobnym bloku H1.
    titleD: 'Cud nie ma terminu.\nTwoje publikacje mają.',
    leadD: 'Z jednego utworu seria editów na Twoje konta. Dni i godziny ustalasz Ty.',
    ctaStart: 'Zacznij za darmo',
    ctaPricing: 'Zobacz cennik',
    // {n} = premia startowa podzielona przez koszt editu (lib/startBonus.ts, z app/).
    // Jednostka wchodzi odmieniona (`editWord`), bo liczba rządzi rzeczownikiem.
    micro: 'Bez karty · {n} {edits} gratis',
    // Cichy link obok mikrotekstu: kotwica do sekcji trzech kroków.
    how: 'Zobacz, jak to działa',
    // Słowa w mapie; konta, godziny i kadry są danymi (`landingFlowMap.data.ts`).
    map: {
      track: 'Nocna jazda',
      // {n} = liczba editów serii przykładowej, jednostka odmieniona (`editWord`).
      series: '{n} {edits}',
      today: 'dziś',
      days: 'pon · wt · śr · czw · pt · sob · nd',
    },
    // Mapa jest dla czytnika JEDNYM obrazem z tym opisem (MAPA D, copy).
    mapAlt: 'Z jednego utworu powstaje seria dziewięciu editów. Trafiają na trzy Twoje konta: TikTok, Instagram i YouTube. Każda publikacja ma dzień i godzinę, które ustaliłeś; dwie już wyszły, jedna czeka na Twoją zgodę, reszta jest zaplanowana.',
  },
  showcase: {
    title: 'Przykładowe edity',
    playExample: 'Odtwórz przykład editu {n}',
    ownClips: 'Twoje klipy',
    packs: 'Paczki klipów',
    hooks: 'Hook na start',
    variants: 'Różne style',
    error: 'Nie udało się odtworzyć przykładu. Wybierz inny edit.',
    retry: 'Spróbuj ponownie',
    // Podpis editu i tytuł utworu na makiecie trzech telefonów (dekoracja, `aria-hidden`).
    // Nazwy kont (`@nocna.jazda`) są nazwami własnymi i stoją w komponencie.
    examples: {
      left: { lyric: 'jeszcze raz', track: 'Przystanek we mgle' },
      center: { lyric: 'nocna jazda', track: 'Nocna jazda' },
      right: { lyric: 'zostań chwilę', track: 'Zielone przejście' },
    },
  },
  how: {
    heading: 'Trzy kroki. Zero montażu.',
    note: 'Nic nie wychodzi bez Twojej zgody.',
    // Bez zdań opisu pod krokami (zasada 8, MAPA 37 „Teksty, które wyleciały”):
    // wizualizacja bez słów mówi to samo, a `note` domyka całą sekcję.
    step1Title: 'Wgraj utwór',
    step2Title: 'Wybierz edity z serii',
    step3Title: 'Zatwierdź harmonogram',
  },
  price: {
    heading: 'Ile to kosztuje',
    // Zasada 8: z dwuzdaniowego akapitu o płaceniu zostaje JEDEN fakt.
    refund: 'Nieudany render nic nie kosztuje.',
    // Linia pieniędzy: cena najtańszego planu z katalogu `/api/billing/plans`,
    // tego samego, z którego liczy Cennik. Bez odpowiedzi linia nie powstaje.
    from: 'Plany od {price} / mies.',
    oneEdit: '1 edit',
    onePublish: '1 publikacja',
    link: 'Zobacz plany i ceny w Cenniku',
  },
  // Sekcja zamykająca: ta sama ciemna scena co pierwszy ekran, jedna akcja i rząd
  // faktów, z których każdy da się sprawdzić na tej samej stronie.
  closing: {
    heading: 'Pierwsza seria jest za darmo.',
    fact1: 'Bez karty na start',
    fact2: 'Twoje pliki widzi tylko Twoje konto',
    fact3: 'Konta łączysz oficjalnym logowaniem platformy',
    fact4: 'Płatności obsługuje Stripe',
    fact5: 'Anulujesz w każdej chwili',
  },
  footer: {
    // Stopka w trzech grupach (R3): Produkt / Pomoc / Prawne, na KAŻDEJ stronie
    // publicznej. Zdanie-tagline, kolumna „Konto” i pasek praw autorskich odeszły.
    groupProduct: 'Produkt',
    groupHelp: 'Pomoc',
    groupLegal: 'Prawne',
    product: 'Produkt',
    funkcje: 'Funkcje',
    jak: 'Jak to działa',
    cennik: 'Cennik',
    faq: 'FAQ',
    login: 'Zaloguj się',
    contact: 'Kontakt',
    terms: 'Regulamin',
    refunds: 'Zwroty i anulowanie',
    // Stopka paczki 37 w jednej linii używała krótszej etykiety; grupa „Pomoc”
    // ma miejsce na pełną nazwę dokumentu.
    refundsShort: 'Zwroty',
    // Krótka etykieta paska prawnego pod kartą logowania i rejestracji (04a–06d):
    // stoi obok „Regulamin” i „Zgłoś treść”, a pełna nazwa dokumentu rozsadza tam wiersz.
    privacyShort: 'Prywatność',
    // Pełna nazwa dokumentu: w grupie „Prawne” skrót „Prywatność” nie nazywa pliku,
    // pod który podpisuje się człowiek zakładający konto.
    privacyFull: 'Polityka prywatności',
    seller: 'JDG Dominik Łupicki',
    report: 'Zgłoś treść',
    copyright: '© 2026 EDIMI · edimi.ai',
    version: 'Publikacja przez oficjalne API TikToka, Instagrama i YouTube',
  },
}
